import { render } from "./date_filter.vue?vue&type=template&id=e1885606"
import script from "./date_filter.vue?vue&type=script&lang=js"
export * from "./date_filter.vue?vue&type=script&lang=js"

import exportComponent from "/media/ctis/developer/WorkSpaceFront/cdas-intranet-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__